module.exports = __webpack_public_path__ + "static/img/jadwal-skda.5d79840.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/jadwal-skda.jpg
// module id = ziBj
// module chunks = 1